export const KIT_VERSION = "3d088fdb";
